import { Image } from '@mantine/core';
import type { Step } from 'react-joyride';
import { TourDefinition } from '../useTour';


export const getInitialTour = ( activeFlags: string[], t: any ): TourDefinition => {
  const steps: Step[] = [
    {
      target: '#tour-app',
      placement: 'center',
      title: t(
        'welcome_title',
        '👋 Welcome to Teselly!' 
      ),
      content: (
        <div style={{ textAlign: 'center' }}>
          <p>
            {t(
              'welcome_description',
              'Let’s take a quick tour of the main sections. Click \'Next\' to continue.'
            )}
          </p>
        </div>
      )
    }
  ];

  const SECTION_ORDER: Array<{ name: string; flagKey: string; title?: string; description?: string, image?:string }> = [
     {
      name: 'dashboard',
      flagKey: 'dashboard',
      title: t( 'dashboard_title', 'Dashboard' ),
      description: t( 'dashboard_description', 'This is your home screen. All of your high-level metrics live here.' )
    },
    {
      name: 'reports',
      flagKey: 'reports',
      title: t( 'reports_title', 'Reports' ),
      description: t( 'reports_description', 'Generate, view, and download reports in this section.' )
    },
    {
      name: 'publications',
      flagKey: 'publications',
      title: t( 'publications_title', 'Publications' ),
      description: t( 'publications_description', 'Manage your publications and sync here.' ),
      image: 'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/images/bg-7.png'
    },
    {
      name: 'inventory',
      flagKey: 'inventory',
      title: t( 'inventory_title', 'Inventory' ),
      description: t( 'inventory_description', 'Track stock levels, adjust quantities, and edit products in Inventory.' )
    },
    {
      name: 'channels',
      flagKey: 'channels',
      title: t( 'channels_title', 'Channels' ),
      description: t( 'channels_description', 'Connect and manage your sales channels (e.g. MercadoLibre, Tiendanube) here.' )
    },
    {
      name: 'billing',
      flagKey: 'billing',
      title: t( 'billing_title', 'Billing' ),
      description: t( 'billing_description', 'View invoices, payment methods, and billing history in Billing.' )
    },
    {
      name: 'orders',
      flagKey: 'orders',
      title: t( 'orders_title', 'Orders' ),
      description: t( 'orders_description', 'Track, fulfill, and manage customer orders in real time.' )
    },
    {
      name: 'warehouses',
      flagKey: 'warehouses',
      title: t( 'warehouses_title', 'Warehouses' ),
      description: t( 'warehouses_description', 'Configure warehouse locations, stock transfers, and storage details.' )
    },
    {
      name: 'interactions',
      flagKey: 'interactions',
      title: t( 'interactions_title', 'Interactions' ),
      description: t( 'interactions_description', 'View customer messages, chats, and interactions here.' )
    },
    {
      // #tour-tours now resolves to the AccountMenu trigger — theme, language and the
      // tutorial list moved into that dropdown's Preferences section (TV1-2299).
      name: 'tours',
      flagKey: 'tours',
      title: t( 'tours_title', 'Tu cuenta' ),
      description: t( 'tours_description', 'Abrí este menú para volver a ver los tutoriales y cambiar el tema o el idioma.' )
    }
  ];

  SECTION_ORDER.forEach(( section ) => {
    if ( activeFlags.includes( section.flagKey )) {
      const slug = section.name;
      steps.push({
        target: `#tour-${slug}`,
        placement: 'bottom',
        title: section.title || '',
        content: (
          <div>
            {section.image && <Image
              radius="md"
              src="https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/images/bg-7.png"
            />}
            <p>{section.description || ''}</p>
          </div>
        )
      });
    }
  });
  steps.push({
   target: '#tour-app',
    placement: 'center',
    title: t( 'finish_title', '🎉 That’s it!' ),
    content: (
      <div style={{ textAlign: 'center' }}>
        <p>
          {t( 'finish_description', 'You now know where to find everything. Enjoy using Teselly!' )}
        </p>
      </div>
    )
  });

  return {
      key: 'initial',
      name: t( 'initial_tour_name' ),
      description: t( 'initial_tour_description' ),
      steps
    };
};